import React, { useMemo } from "react";
import uniqid from "uniqid";
import AppMessageBoxWrapper from "../../UtilsComponents/AppMessageBoxWrapper";
import { StyledMessageText } from "./../../../Styles/StyledComponents";
import { sanitizeHtml } from "../../../utils/security/sanitizeHtml";

interface Props {
  children: any;

  [otherProps: string]: any;
}
const AppRenderNestedText: React.FC<Props> = React.memo(
  ({
    children,

    ...otherProps
  }) => {
     const sanitizedChildren = useMemo(() => sanitizeHtml(children ?? ''), [children]);
    if (!children || children?.length < 1) {
      return null;
    }

    return (
      <StyledMessageText
        dangerouslySetInnerHTML={{
          __html: sanitizedChildren,
        }}
        style={{
          width: "auto",
          maxWidth: "100%",
          display: "block",
          padding: "6px 12px",
        }}
        {...otherProps}
      />
    );
  }
);

export default AppRenderNestedText;
